import React, { useRef } from 'react';
import styled from 'styled-components/macro';

import { sections } from '../../../../common/config';
import Title from './Title';
import Subtitle from './Subtitle';
import useAnimation from './useAnimation';

const Wrapper = styled.div`
  position: relative;
  height: ${sections.height.landing}vh;

  display: flex;
  align-items: center;
  justify-content: center;
`;

const LeafBanner = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  height: 200rem;
  width: 100%;

  background-image: url(/static/images/leaf-banner.png);
  background-repeat: repeat-x;
`;

const Container = styled.div`
  position: relative;
  transform: translateY(${sections.height.landing}vh);
`;

const Mask = styled.div`
  position: absolute;
  height: 100%;
  width: 100%;

  background: var(--background);
  opacity: 1;
`;

const Somersby = () => {
  const mask = useRef<HTMLDivElement>(null);
  const container = useRef<HTMLDivElement>(null);

  useAnimation(mask, container);

  return (
    <Wrapper>
      <LeafBanner />

      <Mask ref={mask} /> {/**Used to hide apple*/}

      <Container ref={container}>
        <Title />
        <Subtitle />
      </Container>
    </Wrapper>
  );
}

export default Somersby;